// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 46 46"
    {...props}
  >
    <path
      fill="#fff"
      d="M3.3335 19C3.3335 16.1997 3.3335 14.7996 3.87846 13.73C4.35783 12.7892 5.12273 12.0243 6.06354 11.545C7.1331 11 8.53323 11 11.3335 11H28.6668C31.4671 11 32.8672 11 33.9368 11.545C34.8776 12.0243 35.6425 12.7892 36.1219 13.73C36.6668 14.7996 36.6668 16.1997 36.6668 19V26.3333C36.6668 29.1336 36.6668 30.5337 36.1219 31.6033C35.6425 32.5441 34.8776 33.309 33.9368 33.7884C32.8672 34.3333 31.4671 34.3333 28.6668 34.3333H11.3335C8.53323 34.3333 7.1331 34.3333 6.06354 33.7884C5.12273 33.309 4.35783 32.5441 3.87846 31.6033C3.3335 30.5337 3.3335 29.1336 3.3335 26.3333V19Z"
    />
    <path
      fill="#fff"
      d="M16.2366 18.5804C16.2366 17.7849 16.2366 17.3872 16.4028 17.1651C16.5477 16.9716 16.7694 16.8506 17.0105 16.8333C17.2872 16.8136 17.6218 17.0287 18.2909 17.4588L24.8623 21.6833C25.4429 22.0565 25.7332 22.2432 25.8335 22.4805C25.9211 22.6878 25.9211 22.9218 25.8335 23.1292C25.7332 23.3665 25.4429 23.5531 24.8623 23.9264L18.2909 28.1508C17.6218 28.581 17.2872 28.7961 17.0105 28.7763C16.7694 28.7591 16.5477 28.638 16.4028 28.4445C16.2366 28.2225 16.2366 27.8248 16.2366 27.0293V18.5804Z"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M12.6199 41C14.8445 39.933 17.3501 39.3333 20.0002 39.3333C22.6502 39.3333 25.1558 39.933 27.3805 41M11.3335 34.3333H28.6668C31.4671 34.3333 32.8672 34.3333 33.9368 33.7884C34.8776 33.309 35.6425 32.5441 36.1219 31.6033C36.6668 30.5337 36.6668 29.1336 36.6668 26.3333V19C36.6668 16.1997 36.6668 14.7996 36.1219 13.73C35.6425 12.7892 34.8776 12.0243 33.9368 11.545C32.8672 11 31.4671 11 28.6668 11H11.3335C8.53323 11 7.1331 11 6.06354 11.545C5.12273 12.0243 4.35783 12.7892 3.87846 13.73C3.3335 14.7996 3.3335 16.1997 3.3335 19V26.3333C3.3335 29.1336 3.3335 30.5337 3.87846 31.6033C4.35783 32.5441 5.12273 33.309 6.06354 33.7884C7.1331 34.3333 8.53323 34.3333 11.3335 34.3333ZM18.2909 28.1508L24.8623 23.9264C25.4429 23.5531 25.7332 23.3665 25.8335 23.1292C25.9211 22.9218 25.9211 22.6878 25.8335 22.4805C25.7332 22.2432 25.4429 22.0565 24.8623 21.6833L18.2909 17.4588C17.6218 17.0287 17.2872 16.8136 17.0105 16.8333C16.7694 16.8506 16.5477 16.9716 16.4028 17.1651C16.2366 17.3872 16.2366 17.7849 16.2366 18.5804V27.0293C16.2366 27.8248 16.2366 28.2225 16.4028 28.4445C16.5477 28.638 16.7694 28.7591 17.0105 28.7763C17.2872 28.7961 17.6218 28.581 18.2909 28.1508Z"
    />
    <circle
      cx={35}
      cy={11}
      r={10}
      fill="#6421B9"
      stroke="#fff"
      strokeWidth={2}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M34.9978 7.14062V10.9978V14.8549M31.1406 10.9978H38.8549"
    />
  </svg>
);
const IconInterviewAdd = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconInterviewAdd;
